import { render } from "./DatasourceResult.vue?vue&type=template&id=778dd790"
import script from "./DatasourceResult.vue?vue&type=script&lang=js"
export * from "./DatasourceResult.vue?vue&type=script&lang=js"

import "./DatasourceResult.vue?vue&type=style&index=0&id=778dd790&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__